import * as React from "react";
import styles from "./error_page.module.sass";
import { RetryButton } from "./retry_button";

export const ErrorPage = (): JSX.Element => (
  <>
    <h1>
      Jejda, tady se něco nenačetlo :-( <br /> Aktualizujte stránku
    </h1>

    <p>&nbsp;</p>

    <p>
      <img
        alt="Chybička se vloudila"
        src="https://cdn.sporilek.cz/uploads/ckeditor/pictures/2057/content_404.jpg"
      />
    </p>

    <p>&nbsp;</p>

    <p>
      Vypadá to, že se při načítání Spořílka stala chybička. Nevěšte hlavu a
      aktualizujte stránku.
    </p>

    <p>
      <a className="button btn-large button-primary" href="/">
        Přejít na hlavní stranu
      </a>
    </p>
  </>
);
